// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1biDS","textarea":"styles_textarea__1nQiT"};